'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../../external/classnames/index.js');

var PropTypes = require('prop-types');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var SecondaryNavItem = function SecondaryNavItem(_ref) {
  var linkText = _ref.linkText,
      link = _ref.link,
      active = _ref.active,
      className = _ref.className;
  var navItemClasses = index['default'](className, 'secondary-nav-item', active && 'active');
  return /*#__PURE__*/React__default['default'].createElement("li", null, /*#__PURE__*/React__default['default'].createElement("a", {
    className: navItemClasses,
    href: link,
    title: linkText
  }, linkText));
};

SecondaryNavItem.defaultProps = {
  className: ''
};
SecondaryNavItem.propTypes = {
  linkText: PropTypes__default['default'].string.isRequired,
  link: PropTypes__default['default'].string.isRequired,
  active: PropTypes__default['default'].bool.isRequired,
  className: PropTypes__default['default'].string
};
exports.SecondaryNavItem = SecondaryNavItem;
exports['default'] = SecondaryNavItem;